import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
import gtm from '@/utils/gtm';

export default function Section1JP({ jumpForm }: any) {
    const { t } = useLang('dp3.landing.section1');

    const handleClick = () => {
        gtm.push({
            __btn_id1: 'dp3-Section1JP .btn',
            __btn_id2: t('btn'),
            __btn_type: 'text',
        });
        jumpForm();
    };

    return (
        <div className={`page-section1JP ${styles.Section1JP} GtmModuleData-section`} data-section-id={'dp3-Section1JP'} data-section-title={t('title')}>
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.Section1JP}`}>
                <div className="content">
                    <EfImg
                        className="img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1749694360708/pc_bg.png"
                        // pad="https://websiteoss.ecoflow.com/upload/image/1749694360556/m_bg.png"
                        h5="https://websiteoss.ecoflow.com/upload/image/1749694360556/m_bg.png"
                    />
                </div>
                <div className="btn GtmModuleData-btn-text" onClick={handleClick}>
                    {t('btn')}
                </div>
            </div>
        </div>
    );
}
